import { IEntityChildren, ZCoreUserGroup } from '../types';
import { AppGlobals } from '../AppGlobals';
import { EntityService } from './EntityService';

export class ZCoreUserGroupService extends EntityService<ZCoreUserGroup> {
    protected childrenEntities = ['ZCoreUserGroupMembers($expand=User)'];

    constructor() {
        super(`/ZCoreUserGroups`);
    }

    public readAllForList(includeClosed?: boolean): Promise<ZCoreUserGroup[]> {
        return this.readAll(
            `?$select=ID,Title`
            + `&$orderby=Title`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            //+ (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public readAllForLookup(includeClosedEntities?: boolean, additionalFields?: string): Promise<ZCoreUserGroup[]> {
        return this.readAll(
            `?$select=ID,Title${additionalFields ? `,${additionalFields}` : ''}`
            + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            //+ (includeClosedEntities ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

        public async entityChildren(id: number): Promise<IEntityChildren[]> {
            return this.entityChildrenSingle(id, 'User Group Members', 'ZCoreUserGroupMembers', true);
        }



}